// extracted by mini-css-extract-plugin
export default {"container":"UserProfileDetails_container__CYYFY","details":"UserProfileDetails_details__YvhbK"};